/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ApplicableHealthMetricsQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ApplicableHealthMetricsQueryOperator");
    }

    getFixupPrototypeFunction() { return ApplicableHealthMetricsQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ApplicableHealthMetricsQueryOperator>): ApplicableHealthMetricsQueryOperator {
        let obj = Object.assign(new ApplicableHealthMetricsQueryOperator(), model);
        ApplicableHealthMetricsQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ApplicableHealthMetricsQueryOperator>): ApplicableHealthMetricsQueryOperator {
        if (!model) return null;
        return ApplicableHealthMetricsQueryOperator.newInstance(<ApplicableHealthMetricsQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ApplicableHealthMetricsQueryOperator) {
        if (!obj) return;

        models.ApplicableHealthMetricsQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ApplicableHealthMetricsQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ApplicableHealthMetricsQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Metrics applicable for evaluating health status of a resource
     */
    applicable_health_metrics: Array<models.ApplicableHealthMetrics>;

}
